import { render, staticRenderFns } from "./platformProtocolSign.vue?vue&type=template&id=77226fd5&scoped=true"
import script from "./platformProtocolSign.vue?vue&type=script&lang=js"
export * from "./platformProtocolSign.vue?vue&type=script&lang=js"
import style0 from "./platformProtocolSign.vue?vue&type=style&index=0&id=77226fd5&prod&scoped=true&lang=css"
import style1 from "./platformProtocolSign.vue?vue&type=style&index=1&id=77226fd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77226fd5",
  null
  
)

export default component.exports